




import { Component, Vue } from 'vue-property-decorator';
import InvoicesTable from '@/modules/invoicing/components/InvoicesTable.vue';

@Component({
  components: {
    InvoicesTable,
  },
})
export default class InvoicesOverview extends Vue {

}
